module.exports = __webpack_public_path__ + "static/giz-b166165e800bda8011d962aba5d98865.jpg";